import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';

/**
 * Props for `FullImageWithItems`.
 */
export type FullImageWithItemsProps =
  SliceComponentProps<Content.FullImageWithItemsSlice>;

/**
 * Component for "FullImageWithItems" Slices.
 */
const FullImageWithItems = ({
  slice,
}: FullImageWithItemsProps): JSX.Element => {
  const {
    primary: { image, title, description, items },
  } = slice;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="max-w-screen-2xl mx-auto px-5 md:px-16 py-16 md:py-28"
    >
      <div className="bg-white-gradient flex flex-col xl:flex-row rounded-[20px] lg:gap-x-20 items-center">
        <PrismicNextImage
          field={image}
          className="w-full xl:w-2/5 rounded-t-[20px] rounded-bl-none xl:rounded-t-none xl:rounded-l-[20px]"
        />
        <div className="w-full p-5 xl:w-3/5 flex flex-col gap-y-6 xl:mr-20">
          <div className="text-primary-darker-green-black">
            <PrismicRichText field={title} />
          </div>
          <PrismicRichText
            field={description}
            components={{
              paragraph: ({ children }) => (
                <p className="text-medium-normal font-normal">{children}</p>
              ),
            }}
          />
          <div className="flex flex-col xl:flex-row gap-y-4">
            {items.map((item, index) => (
              <div key={`item-${index}`} className="flex flex-col gap-y-4">
                <PrismicNextImage field={item.icon} className="h-10" />
                <PrismicRichText field={item.title} />
                <PrismicRichText field={item.description} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FullImageWithItems;
